export enum ROUTER_URL {
  MAIN = '/',
  LOCAL_MAIN = './',
  LOGIN = 'login',
  SIGN_UP = 'signup',
  HOME = 'home',
  RESET_PASSWORD = '/reset-password',

  //organization
  ORGANIZATION = '/organization',
  ORGANIZATION_HOME = '/organization/home',
  ORGANIZATION_PRIVACY_POLICY = '/organization/privacy-policy',
  ORGANIZATION_PROFILE = '/organization/profile',
  ORGANIZATION_NOTIFICATIONS = '/organization/notifications',
  ORGANIZATION_DASHBOARD = '/organization/dashboard',
  ORGANIZATION_TABLES = '/organization/tables',
  ORGANIZATION_TABLES_DETAILS = '/organization/tables/details',
  ORGANIZATION_TERMS_AND_CONDITIONS = '/organization/terms-and-conditions',

  ORGANIZATION_PURCHASE_TICKETS = '/organization/purchase-tickets',
  ORGANIZATION_ADD_EVENT = '/organization/add-event',

  ORGANIZATION_ATTENDEES = '/organization/attendees',
  ORGANIZATION_REPORTS = '/organization/reports',
  ORGANIZATION_AUCTION = '/organization/auction',
  ORGANIZATION_EVENT_SETTINGS = '/organization/event-settings',
  ORGANIZATION_DASHBOARD_TODO_LIST = '/organization/dashboard/todos-list',

  ORGANIZATION_ACCOUNT_SETTINGS = '/organization/profile/account-settings',
  ORGANIZATION_PROFILE_GENERAL = '/organization/profile/general',
  ORGANIZATION_PROFILE_NOTIFICATION = '/organization/profile/notifications',
  ORGANIZATION_PROFILE_BILLING = '/organization/profile/billing',
  ORGANIZATION_PROFILE_TEAM = '/organization/profile/team',
  ORGANIZATION_PROFILE_CONTACT_LIST = '/organization/profile/contact-list',
  ORGANIZATION_PROFILE_INTEGRATION = '/organization/profile/integration',
  ORGANIZATION_HELP_AND_SUPPORT = '/organization/support',

  ORGANIZATION_COMMUNICATIONS_CUSTOMIZATION = '/organization/communications/customization',
  ORGANIZATION_COMMUNICATIONS_TICKETS = '/organization/communications/ticket-invoice',
  ORGANIZATION_COMMUNICATIONS_TICKET_PAYMENTS = '/organization/communications/ticket-payment-confirmation',
  ORGANIZATION_COMMUNICATIONS_TABLE_UPDATE = '/organization/communications/table-update-email',
  ORGANIZATION_COMMUNICATIONS_PATRON_UPDATE = '/organization/communications/patron-update-email',
  ORGANIZATION_COMMUNICATIONS_AUCTION_EMAIL = '/organization/communications/auction-email',
  ORGANIZATION_COMMUNICATIONS_INVOISE_EMAIL = '/organization/communications/invoice-email',
  ORGANIZATION_COMMUNICATIONS_PAYMENT_ACKNOWLEDGEMENT = '/organization/communications/payment-acknowledgement',
  ORGANIZATION_COMMUNICATIONS_CONTRIBUTIONS_SUMMARY = '/organization/communications/contributions-summary',

  ORGANIZATION_PRINTABLES_CUSTOMIZATION = '/organization/printables/customization',
  ORGANIZATION_PRINTABLES_QR = '/organization/printables/qr',
  ORGANIZATION_PRINTABLES_BID_SHEETS = '/organization/printables/bid-sheets',
  ORGANIZATION_PRINTABLES_GUESTS_BY_NAME = '/organization/printables/guests-by-name',
  ORGANIZATION_PRINTABLES_GUESTS_BY_TABLE = '/organization/printables/guests-by-table',
  ORGANIZATION_FUND = '/organization/fundMission',
  ORGANIZATION_CHECK_OUT = '/organization/checkout',
  ORGANIZATION_AUCTION_ENTRY = '/organization/auction-entry',

  ORGANIZATION_AUCTION_ADD_WINNER = '/organization/auction-entry/add-winner',
  ORGANIZATION_WINNER_PROFILE = '/organization/auction-entry/profile',

  ADMIN_DASHBOARD = 'dashboard',
  ADMIN_ORGANIZATION = 'organizations',
  ADMIN_EVENTS = 'events',
  ADMIN_PROFILE_BILLING = 'billing',

  USER_HELP_AND_SUPPORT = 'support',
  USER_NOTIFICATIONS = 'notification',
  USER_ALL_ITEMS = 'allItems',
  USER_SILENT_AUCTION = 'silent-auction',
  USER_LIVE_AUCTION = 'live-auction',
  USER_RAFFLE = 'raffle',
  USER_FUND_MISSIONS = 'fundMissions',
  PROFILE = 'profile',
  USER_ACCOUNT_SETTINGS = 'account-settings',
  USER_RAFFLE_BUY_TICKET = 'raffle/buy-ticket',
  USER_PURCHASE_TICKETS = 'purchase-tickets',
  USER_TABLES = 'my-tables-and-tickets',
  USER_TABLES_DETAILS = 'tables/details',

  PROFILE_GENERAL = 'general',
  PROFILE_NOTIFICATION = 'notifications',
  PROFILE_CONTRIBUTIONS = 'contributions',

  ADMIN = '/admin',
  USER = '/user',

  PRIVATE_PACKAGE = '/private-package',
}
